var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTyltLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 36,
    viewBox: "0 0 89 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Primary logo",
    clipPath: "url(#clip0_1997_16532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8416 32.6845C10.2034 32.6845 9.72793 32.4943 9.34251 32.0864C8.94709 31.6684 8.75688 31.1504 8.75688 30.5022V9.47216H2.18234C1.54666 9.47216 1.03861 9.26694 0.623168 8.84649C0.202717 8.42104 0 7.90048 0 7.25979C0 6.61911 0.202717 6.09855 0.623168 5.67309C1.03611 5.25014 1.54666 5.04492 2.18234 5.04492H19.6936C20.3293 5.04492 20.8448 5.25515 21.2678 5.68811C21.6983 6.12608 21.906 6.64914 21.906 7.28983C21.906 7.61518 21.8509 7.90298 21.7408 8.17077C21.6307 8.43605 21.4805 8.65629 21.2878 8.84149C21.0826 9.0392 20.8498 9.18936 20.5745 9.30449C20.3068 9.41711 20.019 9.46966 19.6936 9.46966H13.089V30.5022C13.089 31.1429 12.8863 31.6359 12.4508 32.0564C12.0129 32.4768 11.4873 32.6845 10.8441 32.6845H10.8416Z",
    fill: "#1F31AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M77.5711 32.6845C76.9329 32.6845 76.4574 32.4943 76.072 32.0864C75.6766 31.6684 75.4864 31.1504 75.4864 30.5022V9.47216H68.9118C68.2761 9.47216 67.7681 9.26694 67.3527 8.84649C66.9322 8.42104 66.7295 7.90048 66.7295 7.25979C66.7295 6.61911 66.9322 6.09855 67.3527 5.67309C67.7656 5.25014 68.2761 5.04492 68.9118 5.04492H86.4231C87.0588 5.04492 87.5743 5.25515 87.9973 5.68811C88.4277 6.12608 88.6355 6.64914 88.6355 7.28983C88.6355 7.61518 88.5804 7.90298 88.4703 8.17077C88.3602 8.43605 88.21 8.65629 88.0173 8.84149C87.8121 9.0392 87.5793 9.18936 87.304 9.30449C87.0363 9.41711 86.7484 9.46966 86.4231 9.46966H79.8185V30.5022C79.8185 31.1429 79.6158 31.6359 79.1803 32.0564C78.7424 32.4768 78.2168 32.6845 77.5736 32.6845H77.5711Z",
    fill: "#1F31AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.8376 8.91956L25.8076 8.88452C25.4072 8.404 25.237 7.88094 25.2695 7.23775C25.3096 6.6271 25.5698 6.10904 26.0654 5.65856C26.2756 5.47837 26.5309 5.33572 26.8237 5.23561C27.074 5.14801 27.3192 5.10547 27.5545 5.10547L27.6821 5.11047C27.9899 5.12549 28.2477 5.19306 28.488 5.3182C28.7508 5.45584 28.981 5.64605 29.1712 5.8788L39.5248 21.5881L37.3325 25.9453L25.8401 8.92206L25.8376 8.91956Z",
    fill: "#1F31AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.5817 35.4277C34.2763 35.4277 33.9785 35.3652 33.6957 35.24C32.592 34.752 32.0915 33.4556 32.5795 32.3519L45.3958 1.73163C45.7461 0.938281 46.5345 0.427734 47.4004 0.427734C47.7057 0.427734 48.0036 0.490301 48.2839 0.615435C49.3875 1.10596 49.8881 2.39985 49.4001 3.50603L36.5838 34.1213C36.2334 34.9147 35.4476 35.4252 34.5792 35.4252L34.5817 35.4277Z",
    fill: "#3ACA65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M62.3216 32.6817C57.3012 32.6817 53.2168 28.5973 53.2168 23.5769V7.04922C53.2168 5.84043 54.1978 4.85938 55.4066 4.85938C56.6154 4.85938 57.5965 5.84043 57.5965 7.04922V23.5769C57.5965 26.1822 59.7163 28.302 62.3216 28.302H68.1703C69.3791 28.302 70.3602 29.283 70.3602 30.4918C70.3602 31.7006 69.3791 32.6817 68.1703 32.6817H62.3216Z",
    fill: "#1F31AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1997_16532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.6325,
    height: 35,
    fill: "white",
    transform: "translate(0 0.427734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTyltLogo);
export default __webpack_public_path__ + "static/media/TyltLogo.3b9164ed229f0b4b0f05b66bad1ce160.svg";
export { ForwardRef as ReactComponent };